module.exports = __webpack_public_path__ + "static/media/bot.25bf8e48.jpg";